import { QRCallToActionWeb } from '../QRCallToAction';
import { EFlyerFooterWeb } from '../EFlyerFooter';
import React from 'react';

import { PtgFeaturesContextType } from './PtgFeaturesContextType';

export const PtgFeaturesWeb = ({ context }) => (
  <div>
    <div id="header-container" className={'border-b-8 border-primary-600'}>
      <div
        id={'header'}
        className={'w-letter mx-auto flex flex-1 justify-between h-32'}
      >
        <div className="h-18 my-auto">
          <img
            src={context.logoUrl}
            alt={context.title}
            className="h-full object-contain mx-auto"
          />
        </div>
        <div className="text-primary-500 text-2xl mt-8 w-1/2">
          <div>{context.heading1}</div>
          <div className="font-bold">{context.heading2}</div>
        </div>
      </div>
    </div>
    <div id="main-container">
      <div id={'main'} className={'w-letter mx-auto'}>
        <div className="my-6">
          <h2 className="text-5xl font-bold text-primary-600 mb-2">
            {context.title}
          </h2>
        </div>
        <div className="flex flex-row">
          <div className="md:w-1/2">
            <img
              src={context.mainImageUrl}
              alt={context.title}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="md:w-1/2 p-6">
            <div className="text-gray-700 pl-4 text-2xl">
              {context.paragraph}
            </div>
          </div>
        </div>
        <div className="my-8">
          <h3 className={'font-bold mb-2 text-xl'}>
            {context.featuresHeading}
          </h3>
          <ul className="list-disc ml-4 text-xl">
            {context.features &&
              context.features.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
          </ul>
        </div>
        <div className={'mt-12'}>
          <QRCallToActionWeb
            callToAction={context.callToAction}
            qrUrl={context.qrUrl}
          />
        </div>
      </div>
    </div>
    <div id="footer-container" className={'bg-primary-600 mt-6'}>
      <div id={'footer'} className={'w-letter ml-auto mr-auto'}>
        <EFlyerFooterWeb footer={context.footer} />
      </div>
    </div>
  </div>
);

PtgFeaturesWeb.propTypes = {
  context: PtgFeaturesContextType.isRequired
};
